import { VideoRecord } from '@/lib/videos';
import { SwingLabVideo } from '../types';
import { logIdPlumbing } from '../lib/idPlumbingLogger';

type DbVideoRow = {
  id: string;
  mux_playback_id: string | null;
  mux_asset_id: string | null;
  // ...
};

export function transformVideoRecord(r: VideoRecord): SwingLabVideo {
  // DEBUG: Log database playback_policy value
  if (import.meta.env.DEV) {
    console.log('[Transform v003] Database playback_policy debug:', {
      id: r.id,
      raw_playback_policy: r.playback_policy,
      typeof_playback_policy: typeof r.playback_policy,
      is_null: r.playback_policy === null,
      is_undefined: r.playback_policy === undefined,
      mux_playback_id: r.mux_playback_id,
      status: r.status
    });
  }

  // Allow videos without Mux IDs (still processing)
  const resolution = r.width && r.height 
    ? `${r.width}x${r.height}` 
    : null;

  logIdPlumbing('Source video resolved', {
    from: 'transform',
    id: r.id,
    playbackId: r.mux_playback_id || 'pending',
    assetId: r.mux_asset_id || 'pending',
    status: r.status,
    playbackPolicy: r.playback_policy || 'null/undefined' // Add policy to logs
  });

  return {
    id: r.id,
    muxPlaybackId: r.mux_playback_id || null,
    muxAssetId: r.mux_asset_id || null,
    createdAt: r.created_at,
    durationSec: r.duration,
    resolution,
    sizeBytes: null,
    status: r.status,
    title: null,
    playbackPolicy: r.playback_policy || 'signed', // FIX: Default to 'signed' if null/undefined
  };
}